import React, { useState } from 'react';

const CLASS_COLORS = {
  discovery_101: 'class-dot-discovery',
  serve_201: 'class-dot-serve',
  values_301: 'class-dot-values',
};

const CLASS_LABELS = {
  discovery_101: 'Discovery 101',
  serve_201: 'Serve 201',
  values_301: 'Values 301',
};

const isInactive = (membership) =>
  typeof membership === 'string' && /inactive/i.test(membership);

function PersonCard({ person, sectionClass, onClick }) {
  const [imgError, setImgError] = useState(false);
  const initials = `${(person.first_name || '')[0] || ''}${(person.last_name || '')[0] || ''}`.toUpperCase();
  const inactive = isInactive(person.membership);

  // classes_taken is already sorted by date from the API
  const classesTaken = person.classes_taken || [];

  return (
    <div className={`person-card${inactive ? ' inactive' : ''}`} onClick={onClick} role="button" tabIndex={0}>
      <div className="person-photo-wrapper">
        {person.avatar && !imgError ? (
          <img className="person-photo" src={person.avatar} alt={`${person.first_name} ${person.last_name}`} onError={() => setImgError(true)} loading="lazy" />
        ) : (
          <div className="person-photo placeholder">{initials}</div>
        )}
        {person.on_volunteer_team && (
          <span className="volunteer-dot" title="On a volunteer team" />
        )}
        {inactive && (
          <span className="inactive-dot" title={person.membership}>⚠</span>
        )}
      </div>
      <div className={`person-name ${person.has_membership_covenant ? 'covenant-highlight' : ''}`}>
        <span className="first">{person.first_name}</span>
        {person.last_name}
      </div>
      {classesTaken.length > 0 && (
        <div className="class-dots">
          {classesTaken.map((c, i) => (
            <span
              key={i}
              className={`class-dot ${CLASS_COLORS[c.class] || ''}`}
              title={CLASS_LABELS[c.class] || c.class}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default PersonCard;
